module.exports = __webpack_public_path__ + "img/sloth-w-coffee.039f1151.svg";